import * as contentful from 'contentful';

// const defaultConfig = {
//   CTF_SPACE_ID: process.env.CTF_SPACE_ID,
//   CTF_CDA_ACCESS_TOKEN: process.env.CTF_CDA_ACCESS_TOKEN
// }

let client = contentful.createClient({
  space:process.env.REACT_APP_CT_SPACE,
  accessToken: process.env.REACT_APP_CT_TOKEN
});



export const getByEntry= async (id="6M7mHqyYqNb7vqy7Sqg1aW")=> {
  return await client.getEntry(id).then(entry => entry);
}

export const getBlogPosts= async (params = {})=>{
  const {
    content_type,
    id,
    name,
    slug,
    limit,
    skip} = params;

  const type = content_type ? content_type : 'blogPost';

  let query = {
    content_type:type,
    //order: '-sys.createdAt',
    order:'-fields.publishDate'
  };

  if(params){
    if(limit) query = {...query, limit};
    if(skip ) query = {...query, skip};
    if(name) query = {...query, 'fields.name[match]': name};
    if(slug) query = {...query, 'fields.slug[match]': name};
    if(id) query = {...query, 'sys.id[match]': id};

    // if(tag) {
    //   query = {...query,
    //     'fields.tags.fields.title[match]': tag
    //   }
    // }
  }

  return await client.getEntries(query).then(res=>res).catch(err=>err);
}


